export const PAYWALL_ENTRY_POINTS = ["funnel", "mobile_app", "lifecycle_email"] as const;

export type PaywallEntryPoint = (typeof PAYWALL_ENTRY_POINTS)[number];

export type PaywallEntryContext = {
  entryPoint: PaywallEntryPoint;
  source: string;
  isAppEntry: boolean;
};

const APP_SOURCES = new Set(["ios_app", "android_app", "mobile_app"]);

export const normalizePaywallEntryPoint = (value: unknown): PaywallEntryPoint => {
  if (typeof value !== "string") return "funnel";
  const normalized = value.trim().toLowerCase();
  return PAYWALL_ENTRY_POINTS.includes(normalized as PaywallEntryPoint)
    ? normalized as PaywallEntryPoint
    : "funnel";
};

export const resolvePaywallEntryContextFromUrl = (
  urlLike: URL | string = window.location.href
): PaywallEntryContext => {
  const url = typeof urlLike === "string" ? new URL(urlLike) : urlLike;
  const source = url.searchParams.get("source")?.trim().toLowerCase() ?? "";

  if (APP_SOURCES.has(source)) {
    return { entryPoint: "mobile_app", source, isAppEntry: true };
  }

  if (source === "lifecycle_email" || url.searchParams.get("utm_medium") === "email") {
    return { entryPoint: "lifecycle_email", source: source || "lifecycle_email", isAppEntry: false };
  }

  return { entryPoint: "funnel", source: source || "direct", isAppEntry: false };
};

export const sourceQueryForEntryPoint = (entryPoint: PaywallEntryPoint): string =>
  entryPoint === "funnel" ? "" : `&source=${encodeURIComponent(entryPoint)}`;
